/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-unused-vars */
import { Routes, Route } from "react-router-dom";
import Dashboard from "./Frontend/Pages/Dashboard";
import GetProducts from "./Frontend/Products/GetProducts";
import NotFound from "./Frontend/Pages/NotFound";
import SideBar from "./Frontend/Navbar/SideBar";
import { Box } from "@mui/material";
import { createContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./Store/slices/cartSlice";
import { addToCart2 } from "./Store/slices/cartSlice2";
import { message } from "antd";

import AddProducts from "./Frontend/Products/AddProducts";
import UpdateProducts from "./Frontend/Products/UpdateProducts";
import i18 from "./i18";
import AddStudent from "./Frontend/ListStudent/AddStudent";
import GetStudent from "./Frontend/ListStudent/GetStudent";
import UpdateStudent from "./Frontend/ListStudent/UpdateStudent";
import Installment from "./Frontend/ListStudent/Installment";
import AddExpenses from "./Frontend/Expenses/AddExpenses";
import GetExpenses from "./Frontend/Expenses/GetExpenses";
import UpdateExpenses from "./Frontend/Expenses/UpdateExpenses";
import AddTeacher from "./ListTeachers/AddTeacher";
import GetTeacher from "./ListTeachers/GetTeacher";
import UpdateTeacher from "./ListTeachers/UpdateTeacher";
import Profile from "./Frontend/Profile/Profile";
import AddUser from "./Frontend/Register/AddUser";
import GetUser from "./Frontend/Register/GetUser";
import UpdateUser from "./Frontend/Register/UpdateUser";
import PrintStudent from "./Frontend/ListStudent/PrintStudent";
import Shopping from "./Frontend/Products/Shopping";
import AddBook from "./Frontend/Books/AddBook";
import GetBook from "./Frontend/Books/GetBook";
import ShoppingBook from "./Frontend/Books/ShoppingBook";
import UpdateBook from "./Frontend/Books/UpdateBook";
import Raptors from "./Frontend/Raptors/Raptors";
import Salary from "./ListTeachers/Salary";
import GetExpensesReport from "./Frontend/Raptors/GetExpensesReport";
import GetExpensesReportYears from "./Frontend/Raptors/GetExpensesReportYears";
import GetStudentReport from "./Frontend/Raptors/GetStudentReport";
import GetTeacherReportMonth from "./Frontend/Raptors/GetTeacherReportMonth";
import GetTeacherReportYear from "./Frontend/Raptors/GetTeacherReportYear";
import GetUnpaidStudentsReport from "./Frontend/Raptors/GetUnpaidStudentsReport";
import GetDiscountedStudent from "./Frontend/Raptors/GetDiscountedStudent";
import LoginPage from "./Frontend/auth/MyLoginPage";
import PaymentStudent from "./Frontend/ListStudent/PaymentStudent";
import UpdateTuition from "./Frontend/ListStudent/UpdateTuition";
import PostTuition from "./Frontend/ListStudent/PostTuition";
import Update_PaymentStudent from "./Frontend/ListStudent/Update_PaymentStudent";

import GetReportsTuitionPayments from "./Frontend/Raptors/GetReportsTuitionPayments";
import GetExpensesReportToday from "./Frontend/Raptors/GetExpensesReportToday";

const MyContext = createContext();
const Home = () => {
  // useEffect(() => {
  //   alert(isToggleSidebar);
  // }, [isToggleSidebar]);
  //TODO: =======================================
  useEffect(() => {
    i18.changeLanguage("en");
  }, []);

  //TODO: react redux
  // eslint-disable-next-line no-unused-vars
  const [show, setShow] = useState(true);
  const [show2, setShow2] = useState(true);

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart?.items || []);
  const handleClick = (item) => {
    dispatch(addToCart(item));
    // Notify user about the addition to the cart
    message.success("Add  to Card");
    // console.log("addddddddd", cart);
  };
  const cart2 = useSelector((state) => state.cart2?.items || []);
  const handleClick2 = (item) => {
    dispatch(addToCart2(item));
    // Notify user about the addition to the cart
    message.success("Add Book to cart");
    // console.log("addddddddd", cart);
  };
  //TODO: =======================================

  return (
    <>
      {/* <Navbar setShow={setShow} size={cart.length} /> */}
      {/* <Navbar /> */}
      <Box sx={{ display: "flex" }}>
        <div className={`sidebarWrapper toggle`}>
          <SideBar />
        </div>
        <div className={`content toggle`}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            {/* //TODO: Products */}
            <Route path="/AddProducts" element={<AddProducts />} />

            <Route
              path="/GetProducts"
              element={
                <GetProducts
                  handleClick={handleClick}
                  setShow={setShow}
                  size={cart.length}
                />
              }
            />
            <Route path="/Shopping" element={<Shopping cart={cart} />} />
            <Route
              path="/GetProducts/UpdateProducts/:id"
              element={<UpdateProducts />}
            />
            {/* //TODO: Book */}
            <Route path="/AddBook" element={<AddBook />} />
            <Route
              path="/get-books"
              element={
                <GetBook
                  handleClick2={handleClick2}
                  setShow2={setShow2}
                  size2={cart2.length}
                />
              }
            />
            <Route
              path="/ShoppingBook"
              element={<ShoppingBook cart={cart2} />}
            />
            <Route path="/get-books/UpdateBook/:id" element={<UpdateBook />} />
            {/* // TODO: List Student */}
            <Route path="/AddStudent" element={<AddStudent />} />
            <Route path="/GetStudent" element={<GetStudent />} />
            <Route
              path="/GetStudent/PaymentStudent/:id"
              element={<PaymentStudent />}
            />
            <Route
              path="/GetStudent/PrintStudent/:id"
              element={<PrintStudent />}
            />
            <Route
              path="/GetStudent/UpdateStudent/:id"
              element={<UpdateStudent />}
            />
            <Route path="/:id/create-tuition" element={<PostTuition />} />
            <Route
              path="/GetStudent/ViewStudent/:id"
              element={<Installment />}
            />
            {/* <Route path="/update-tuition/:id" element={<UpdateTuition />} /> */}
            <Route
              path="/update-tuition/:tuitionId"
              element={<UpdateTuition />}
            />
            <Route
              path="/Update_PaymentStudent/:id"
              element={<Update_PaymentStudent />}
            />
            {/* // TODO: List Expenses */}
            <Route path="/AddExpenses" element={<AddExpenses />} />
            <Route path="/GetExpenses" element={<GetExpenses />} />
            <Route
              path="/GetExpenses/UpdateExpenses/:id"
              element={<UpdateExpenses />}
            />

            {/* // TODO: List Teacher */}
            <Route path="/AddTeacher" element={<AddTeacher />} />
            <Route path="/GetTeacher" element={<GetTeacher />} />
            <Route path="/GetTeacher/Salary/:id" element={<Salary />} />
            <Route
              path="/GetTeacher/UpdateTeacher/:id"
              element={<UpdateTeacher />}
            />

            {/* //TODO: Register -------------------- */}
            <Route path="/GetUser" element={<GetUser />} />
            <Route path="/AddUser" element={<AddUser />} />
            <Route path="/GetUser/UpdateUser/:id" element={<UpdateUser />} />
            {/* //TODO: ------------------------------- */}
            {/* //TODO: Profile -------------------- */}
            <Route path="/Profile" element={<Profile />} />
            {/* //TODO: Raptors---------------------- */}
            <Route path="/Raptors" element={<Raptors />} />
            <Route path="/GetExpensesReport" element={<GetExpensesReport />} />
            <Route
              path="/GetExpensesReportYears"
              element={<GetExpensesReportYears />}
            />
            <Route path="/GetStudentReport" element={<GetStudentReport />} />
            <Route
              path="/GetTeacherReportMonth"
              element={<GetTeacherReportMonth />}
            />
            <Route
              path="/GetTeacherReportYear"
              element={<GetTeacherReportYear />}
            />
            <Route
              path="/GetUnpaidStudentsReport"
              element={<GetUnpaidStudentsReport />}
            />
            <Route
              path="/GetDiscountedStudent"
              element={<GetDiscountedStudent />}
            />
            <Route
              path="/GetReportsTuitionPayments"
              element={<GetReportsTuitionPayments />}
            />
            <Route
              path="/GetExpensesReportToday"
              element={<GetExpensesReportToday />}
            />

            {/* //TODO: ------------------------------- */}

            <Route path="/Login" element={<LoginPage />} />
            <Route exact path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Box>
    </>
  );
};

export default Home;
